module.exports = __webpack_public_path__ + "static/img/qrguanfang.bf1b7e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/qrguanfang.jpg
// module id = lsiS
// module chunks = 1